import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import {
  LOCAL_STORAGE_KEYS_TOKEN,
  LocalStorageKeysTypes,
} from './models/local-storage-store.models';
import { LocalStorageEffects } from './store/local-storage.effects';
import { LocalStorageManagementFeature } from './store/local-storage.reducers';

@NgModule({
  providers: [
    {
      provide: LOCAL_STORAGE_KEYS_TOKEN,
      useValue: LocalStorageKeysTypes,
    },
    provideEffects(LocalStorageEffects),
    provideState(LocalStorageManagementFeature),
  ],
})
export class LocalStorageManagementModule {}
